import React, { forwardRef } from 'react'
import styles from './GlobalButton.module.scss'
import { Button, ButtonProps } from 'antd'

interface ButtonGlobalProps extends ButtonProps {
  color?: string
  customType?:
    | 'primary'
    | 'default'
    | 'success'
    | 'danger'
    | 'disabled'
    | 'cancel'
  backgroundColor?: string
  leftIcon?: React.ReactNode,
  cursor?:string
  ref?: any
}

const ButtonGlobal = forwardRef<HTMLButtonElement, ButtonGlobalProps>(function ButtonGlobal({
  color,
  size = 'medium',
  backgroundColor,
  customType = 'primary',
  leftIcon,
  loading,
  onClick,
  disabled,
  cursor,
  children,
  style,
  ...rest
}, ref) {
  const appliedCustomType = disabled ? 'disabled' : customType;
  
  return (
    <Button
      ref={ref}
      className={`${styles.custombutton} ${styles[size]} ${styles[appliedCustomType]} `}
      style={{ color, backgroundColor,cursor, ...style }}
      onClick={onClick}
      disabled={disabled}
      loading={loading}
      icon={leftIcon}
      data-my-attribute="globalButton"
      {...rest}
    >
      {children}
    </Button>
  )
}) 

export default ButtonGlobal
